import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    brand: "Victoria Stil",
    nav_locations: "Ubicaciones",
    nav_pricing: "Precios & Servicios",
    nav_gallery: "Galería",
    nav_reviews: "Opiniones",
    hero_title: "Arreglos y Confección Profesional",
    hero_subtitle: "Devolvemos la vida a tus prendas con artesanía y cuidado. Desde simples bajos hasta alteraciones complejas, lo hacemos todo.",
    hero_reviews: "★★★★★ 4.9 de 500+ clientes",
    hero_trust: "Confiado por cientos de clientes satisfechos en la Costa Blanca",
    btn_get_started: "Empezar (chat) →",
    hero_subline: "Presupuesto gratis · Respuesta rápida · Sin compromiso",
    locations_title: "Nuestras Tiendas",
    locations_subtitle: "Tres ubicaciones para servirte mejor",
    view_map: "Ver en mapa →",
    gallery_title: "Nuestro Trabajo",
    gallery_subtitle: "Transformaciones que hemos creado para nuestros clientes",
    gal_suit: "Confección de Trajes",
    gal_suit_desc: "Traje de negocios a medida",
    gal_dress: "Alteración de Vestidos",
    gal_dress_desc: "Redimensionado de vestido de noche",
    gal_leather: "Reparación de Cuero",
    gal_leather_desc: "Restauración de chaqueta",
    gal_denim: "Reparación de Denim",
    gal_denim_desc: "Remiendos en jeans desgastados",
    gal_traditional: "Ropa Tradicional",
    gal_traditional_desc: "Ajustes de prendas culturales",
    gal_embroidery: "Bordados",
    gal_embroidery_desc: "Trabajo de monograma personalizado",
    reviews_title: "Opiniones de Clientes",
    reviews_subtitle: "Lo que nuestros clientes dicen de nosotros",
    review_1: "Muy buen servicio de costura! Me hicieron un arreglo complicado y quedó como nuevo. Además, el trato fue muy amable y el trabajo, rápido y profesional. Sin duda volveré.",
    review_2: "Una experiencia excelente de principio a fin. La calidad del arreglo, velocidad de ejecución y amabilidad de los trabajadores superó mis expectativos. Local limpio, precios justos y un trabajo muy resultón. Repetiría sin dudarlo.",
    review_3: "Una persona muy servicial que me dejó plantado. Me arregló los pantalones cortos rápidamente y a un precio razonable. Un trabajo muy bien hecho.",
    modal_title: "¡Gracias!",
    modal_message: "Tu solicitud ha sido enviada correctamente. Te contactaremos en breve.",
    footer_desc: "Servicios profesionales de arreglos y confección desde 2010. Aportamos artesanía y cuidado a cada prenda.",
    footer_links: "Enlaces Rápidos",
    footer_services: "Servicios",
    footer_contact: "Contacto",
    footer_hours: "Lun-Vie: 9:00-14:30, 16:30-20:00",
    footer_rights: "Todos los derechos reservados.",
    svc_alterations: "Arreglos",
    svc_repairs: "Reparaciones",
    svc_tailoring: "Confección a Medida",
    svc_leather: "Trabajos en Cuero",
    pricing_intro: "Tarifas orientativas para nuestros servicios estándar. Los precios pueden variar según la complejidad de la prenda. Solicita tu presupuesto personalizado sin compromiso.",
    cat_alterations: "Arreglos de Ropa",
    sub_shirts: "CAMISAS Y BLUSAS",
    item_taper_shirt: "Ajuste con pinzas",
    item_shorten_sleeve_cuff: "Acortar manga (puño)",
    item_shorten_sleeve_shoulder: "Acortar manga (hombro)",
    item_shorten_shirt: "Acortar largo",
    item_collar: "Arreglar cuello / escote",
    item_narrow_sleeve: "Estrechar manga",
    sub_trousers: "PANTALONES, VAQUEROS Y FALDAS",
    item_hem_length: "Ajustar largo (bajo)",
    item_waist_length: "Ajustar largo (cintura)",
    item_waist_trouser: "Ajustar cintura (pantalón/falda)",
    item_waist_denim: "Ajustar cintura (vaquero)",
    item_waist_suit: "Ajustar cintura (traje)",
    item_taper_legs: "Estrechar pernera",
    sub_bridal: "NOVIA",
    item_bride_length: "Ajustar largo",
    item_bride_bodice: "Ajustar corpiño",
    item_bride_taper: "Estrechar (costuras)",
    item_bride_straps: "Acortar tirantes",
    sub_jackets: "CHAQUETAS Y ABRIGOS",
    item_jacket_length: "Acortar / alargar",
    item_jacket_sleeve: "Ajustar manga",
    item_jacket_shoulder: "Levantar hombros",
    item_jacket_taper: "Estrechar",
    sub_dresses: "VESTIDOS",
    item_dress_hem: "Ajustar largo (bajo)",
    item_dress_waist: "Ajustar largo (cintura)",
    item_dress_straps: "Acortar tirantes",
    item_dress_neckline: "Rediseñar escote",
    item_dress_taper: "Estrechar (costuras)",
    sub_evening: "ROPA DE FIESTA",
    item_evening_length: "Ajustar largo",
    item_evening_bodice: "Ajustar corpiño",
    item_evening_taper: "Estrechar (costuras)",
    item_evening_straps: "Acortar tirantes",
    cat_repairs: "Reparaciones",
    sub_general: "GENERAL",
    item_repair_seam: "Reparar costura",
    item_button: "Coser botón",
    item_zipper: "Cambiar cremallera",
    item_tear: "Reparar desgarro",
    item_repair_lining: "Reparar forro",
    item_replace_lining: "Cambiar forro",
    sub_knitwear: "PUNTO",
    item_debobble: "Quitar bolitas",
    item_darn_visible: "Remendar (visible), por agujero",
    item_darn_invisible: "Remendar (invisible), por agujero",
    sub_outerwear: "ABRIGOS",
    item_outer_tear: "Reparar desgarro",
    item_outer_zipper: "Cambiar cremallera",
    item_outer_lining: "Cambiar forro",
    cat_bespoke: "Servicios a Medida",
    item_hand_embroidery: "Bordado a mano",
    item_machine_embroidery: "Bordado a máquina",
    item_embellishment: "Reparar / cambiar adorno",
    item_dyeing: "Técnicas de tinte",
    item_denim_paint: "Pintura en vaquero",
    item_upcycling: "Reutilizar prenda",
    item_made_measure: "Confección a medida",
    item_fur: "Reparación y restauración de piel",
    price_on_request: "Bajo presupuesto",
    cat_leather: "Cuero y Bolsos",
    item_bag_zipper: "Cambiar cremallera",
    item_bag_colour: "Restauración de color",
    item_bag_touchup: "Retoque de color",
    item_bag_change_colour: "Cambiar color",
    item_bag_lining: "Cambiar forro",
    pricing_cta: "¿Necesitas un presupuesto personalizado?",
    btn_quote: "Solicitar Presupuesto",
    pricing_title: "Precios y Servicios"
  },
  en: {
    brand: "Victoria Stil",
    nav_locations: "Locations",
    nav_pricing: "Pricing & Services",
    nav_gallery: "Gallery",
    nav_reviews: "Reviews",
    hero_title: "Professional Tailoring and Repairs",
    hero_subtitle: "Bringing your garments back to life with craftsmanship and care. From simple hems to complex alterations, we do it all.",
    hero_reviews: "★★★★★ 4.9 from 500+ customers",
    hero_trust: "Trusted by hundreds of happy customers across Costa Blanca",
    btn_get_started: "Get started (chat) →",
    hero_subline: "Free quote · Quick response · No commitment",
    locations_title: "Our Stores",
    locations_subtitle: "Three locations to serve you better",
    view_map: "View on map →",
    gallery_title: "Our Work",
    gallery_subtitle: "Transformations we've created for our clients",
    gal_suit: "Suit Tailoring",
    gal_suit_desc: "Custom fitted business suit",
    gal_dress: "Dress Alteration",
    gal_dress_desc: "Evening gown resizing",
    gal_leather: "Leather Repair",
    gal_leather_desc: "Jacket restoration",
    gal_denim: "Denim Repair",
    gal_denim_desc: "Distressed jeans mending",
    gal_traditional: "Traditional Wear",
    gal_traditional_desc: "Cultural garment adjustments",
    gal_embroidery: "Embroidery",
    gal_embroidery_desc: "Custom monogram work",
    reviews_title: "Client Reviews",
    reviews_subtitle: "What our customers say about us",
    review_1: "Excellent tailoring service! They did a complicated alteration for me and it looks brand new. Plus, the staff was very friendly and the work was quick and professional. I'll definitely be back.",
    review_2: "An excellent experience from start to finish. The quality of the work, the speed of execution, and the friendliness of the staff exceeded my expectations. The place was clean, the prices fair, and the work was very effective. I would definitely return.",
    review_3: "Very helpful person who blew me off. She repaired my shorts quickly and reasonably. Nicely done job.",
    modal_title: "Thank You!",
    modal_message: "Your request has been submitted successfully. We'll contact you shortly.",
    footer_desc: "Professional tailoring and repair services since 2010. We bring craftsmanship and care to every garment.",
    footer_links: "Quick Links",
    footer_services: "Services",
    footer_contact: "Contact",
    footer_hours: "Mon-Fri: 9:00-14:30, 16:30-20:00",
    footer_rights: "All rights reserved.",
    svc_alterations: "Alterations",
    svc_repairs: "Repairs",
    svc_tailoring: "Custom Tailoring",
    svc_leather: "Leather Work",
    pricing_intro: "Guideline prices for our standard services. Prices may vary depending on garment complexity. Request your personalised quote with no obligation.",
    cat_alterations: "Clothing Alterations",
    sub_shirts: "SHIRTS & BLOUSES",
    item_taper_shirt: "Tapering (add darts)",
    item_shorten_sleeve_cuff: "Shorten sleeves (from cuff)",
    item_shorten_sleeve_shoulder: "Shorten sleeves (from shoulder)",
    item_shorten_shirt: "Shorten length",
    item_collar: "Amend collar / neckline",
    item_narrow_sleeve: "Narrow sleeves",
    sub_trousers: "TROUSERS, JEANS & SKIRTS",
    item_hem_length: "Adjust length (from hem)",
    item_waist_length: "Adjust length (from waist)",
    item_waist_trouser: "Adjust waistband (trousers/skirt)",
    item_waist_denim: "Adjust waistband (denim)",
    item_waist_suit: "Adjust waistband (suit trousers)",
    item_taper_legs: "Taper legs",
    sub_bridal: "BRIDAL",
    item_bride_length: "Adjust length",
    item_bride_bodice: "Adjust bodice",
    item_bride_taper: "Taper (from seams)",
    item_bride_straps: "Shorten straps",
    sub_jackets: "JACKETS & COATS",
    item_jacket_length: "Shorten / lengthen",
    item_jacket_sleeve: "Adjust sleeve length",
    item_jacket_shoulder: "Lift shoulders",
    item_jacket_taper: "Taper width",
    sub_dresses: "DRESSES",
    item_dress_hem: "Adjust length (from hem)",
    item_dress_waist: "Adjust length (from waist)",
    item_dress_straps: "Shorten straps",
    item_dress_neckline: "Reshape neckline",
    item_dress_taper: "Taper (from seams)",
    sub_evening: "EVENINGWEAR",
    item_evening_length: "Adjust length",
    item_evening_bodice: "Adjust bodice",
    item_evening_taper: "Taper (from seams)",
    item_evening_straps: "Shorten straps",
    cat_repairs: "Clothing Repairs",
    sub_general: "GENERAL",
    item_repair_seam: "Repair seam",
    item_button: "Reattach button",
    item_zipper: "Zipper replacement",
    item_tear: "Repair tear",
    item_repair_lining: "Repair lining",
    item_replace_lining: "Replace lining",
    sub_knitwear: "KNITWEAR",
    item_debobble: "Debobbling",
    item_darn_visible: "Darning (visible), per hole",
    item_darn_invisible: "Darning (invisible), per hole",
    sub_outerwear: "OUTERWEAR",
    item_outer_tear: "Tear repair",
    item_outer_zipper: "Replace zipper",
    item_outer_lining: "Replace lining",
    cat_bespoke: "Bespoke Services",
    item_hand_embroidery: "Hand embroidery",
    item_machine_embroidery: "Machine embroidery",
    item_embellishment: "Repair / replace embellishment",
    item_dyeing: "Colour dyeing techniques",
    item_denim_paint: "Denim painting",
    item_upcycling: "Re-purpose garment / upcycling",
    item_made_measure: "Made to measure",
    item_fur: "Fur repairs & restoration",
    price_on_request: "Upon request",
    cat_leather: "Leather & Bags",
    item_bag_zipper: "Zipper replacement",
    item_bag_colour: "Colour restoration",
    item_bag_touchup: "Colour touch-up",
    item_bag_change_colour: "Change colour",
    item_bag_lining: "Change lining",
    pricing_cta: "Need a personalised quote?",
    btn_quote: "Request Quote",
    pricing_title: "Pricing & Services"
  },
  ro: {
    brand: "Victoria Stil",
    nav_locations: "Locații",
    nav_pricing: "Prețuri & Servicii",
    nav_gallery: "Galerie",
    nav_reviews: "Recenzii",
    hero_title: "Croitorie și Reparații Profesionale",
    hero_subtitle: "Redăm viața hainelor tale cu măiestrie și grijă. De la tivuri simple la alterații complexe, facem totul.",
    hero_reviews: "★★★★★ 4.9 din 500+ clienți",
    hero_trust: "De încredere pentru sute de clienți mulțumiți pe Costa Blanca",
    btn_get_started: "Începe (chat) →",
    hero_subline: "Ofertă gratuită · Răspuns rapid · Fără obligații",
    locations_title: "Magazinele Noastre",
    locations_subtitle: "Trei locații pentru a te servi mai bine",
    view_map: "Vezi pe hartă →",
    gallery_title: "Lucrările Noastre",
    gallery_subtitle: "Transformări create pentru clienții noștri",
    gal_suit: "Croitorie Costume",
    gal_suit_desc: "Costum de afaceri la comandă",
    gal_dress: "Alterație Rochii",
    gal_dress_desc: "Redimensionare rochie de seară",
    gal_leather: "Reparație Piele",
    gal_leather_desc: "Restaurare geacă",
    gal_denim: "Reparație Denim",
    gal_denim_desc: "Cusături în blugi uzati",
    gal_traditional: "Haine Tradiționale",
    gal_traditional_desc: "Ajustări haine culturale",
    gal_embroidery: "Broderii",
    gal_embroidery_desc: "Lucru monogramă personalizat",
    reviews_title: "Recenzii Clienți",
    reviews_subtitle: "Ce spun clienții noștri despre noi",
    review_1: "Serviciu de croitorie excelent! Mi-au făcut o modificare complicată și haina arată ca nouă. În plus, personalul a fost foarte prietenos, iar lucrarea a fost realizată rapid și profesional. Cu siguranță voi reveni.",
    review_2: "O experiență excelentă de la început până la sfârșit. Calitatea lucrării, rapiditatea execuției și amabilitatea personalului mi-au depășit așteptările. Locul era curat, prețurile rezonabile, iar lucrarea a fost foarte eficientă. Cu siguranță aș reveni.",
    review_3: "O persoană foarte amabilă, care m-a lăsat baltă. Mi-a reparat pantalonii scurți rapid și la un preț rezonabil. O treabă bine făcută.",
    modal_title: "Mulțumim!",
    modal_message: "Solicitarea ta a fost trimisă cu succes. Te contactăm în curând.",
    footer_desc: "Servicii profesionale de croitorie și reparații din 2010. Aducem măiestrie și grijă fiecărei haine.",
    footer_links: "Linkuri Rapide",
    footer_services: "Servicii",
    footer_contact: "Contact",
    footer_hours: "Lun-Vin: 9:00-14:30, 16:30-20:00",
    footer_rights: "Toate drepturile rezervate.",
    svc_alterations: "Alterații",
    svc_repairs: "Reparații",
    svc_tailoring: "Croitorie la Comandă",
    svc_leather: "Lucrări în Piele",
    pricing_intro: "Tarife orientative pentru serviciile noastre standard. Prețurile pot varia în funcție de complexitatea hainei. Solicitați devizul personalizat fără obligație.",
    cat_alterations: "Alterații Haine",
    sub_shirts: "CĂMĂȘI ȘI BLUZE",
    item_taper_shirt: "Ajustare cu pensete",
    item_shorten_sleeve_cuff: "Scurtare mânecă (de la manșetă)",
    item_shorten_sleeve_shoulder: "Scurtare mânecă (de la umăr)",
    item_shorten_shirt: "Scurtare lungime",
    item_collar: "Modificare guler / decolteu",
    item_narrow_sleeve: "Subțiere mânecă",
    sub_trousers: "PANTALONI, BLUGI ȘI FUSTE",
    item_hem_length: "Ajustare lungime (de la tiv)",
    item_waist_length: "Ajustare lungime (de la talie)",
    item_waist_trouser: "Ajustare talie (pantaloni/fustă)",
    item_waist_denim: "Ajustare talie (blugi)",
    item_waist_suit: "Ajustare talie (costum)",
    item_taper_legs: "Subțiere picior",
    sub_bridal: "MIREASĂ",
    item_bride_length: "Ajustare lungime",
    item_bride_bodice: "Ajustare corsaj",
    item_bride_taper: "Subțiere (de la cusături)",
    item_bride_straps: "Scurtare bretele",
    sub_jackets: "GECI ȘI PALTOANE",
    item_jacket_length: "Scurtare / prelungire",
    item_jacket_sleeve: "Ajustare lungime mânecă",
    item_jacket_shoulder: "Ridicare umeri",
    item_jacket_taper: "Subțiere",
    sub_dresses: "ROCHII",
    item_dress_hem: "Ajustare lungime (de la tiv)",
    item_dress_waist: "Ajustare lungime (de la talie)",
    item_dress_straps: "Scurtare bretele",
    item_dress_neckline: "Redesign decolteu",
    item_dress_taper: "Subțiere (de la cusături)",
    sub_evening: "ROCHIE DE SEARĂ",
    item_evening_length: "Ajustare lungime",
    item_evening_bodice: "Ajustare corsaj",
    item_evening_taper: "Subțiere (de la cusături)",
    item_evening_straps: "Scurtare bretele",
    cat_repairs: "Reparații",
    sub_general: "GENERAL",
    item_repair_seam: "Reparare cusătură",
    item_button: "Cusere nasture",
    item_zipper: "Înlocuire fermoar",
    item_tear: "Reparare ruptură",
    item_repair_lining: "Reparare căptușeală",
    item_replace_lining: "Înlocuire căptușeală",
    sub_knitwear: "TRICOTATE",
    item_debobble: "Îndepărtare scame",
    item_darn_visible: "Peticire (vizibilă), per gaură",
    item_darn_invisible: "Peticire (invizibilă), per gaură",
    sub_outerwear: "GECI",
    item_outer_tear: "Reparare ruptură",
    item_outer_zipper: "Înlocuire fermoar",
    item_outer_lining: "Înlocuire căptușeală",
    cat_bespoke: "Servicii la Comandă",
    item_hand_embroidery: "Broderie manuală",
    item_machine_embroidery: "Broderie mașină",
    item_embellishment: "Reparare / înlocuire decorațiune",
    item_dyeing: "Tehnici de vopsire",
    item_denim_paint: "Pictură pe blugi",
    item_upcycling: "Reutilizare haină",
    item_made_measure: "Confeccionare la comandă",
    item_fur: "Reparații și restaurare blană",
    price_on_request: "La cerere",
    cat_leather: "Piele și Genți",
    item_bag_zipper: "Înlocuire fermoar",
    item_bag_colour: "Restaurare culoare",
    item_bag_touchup: "Retuș culoare",
    item_bag_change_colour: "Schimbare culoare",
    item_bag_lining: "Schimbare căptușeală",
    pricing_cta: "Aveți nevoie de un deviz personalizat?",
    btn_quote: "Solicită Deviz",
    pricing_title: "Prețuri și Servicii"
  },
  ru: {
    brand: "Victoria Stil",
    nav_locations: "Адреса",
    nav_pricing: "Цены & Услуги",
    nav_gallery: "Галерея",
    nav_reviews: "Отзывы",
    hero_title: "Профессиональный Пошив и Ремонт",
    hero_subtitle: "Возвращаем жизнь вашей одежде с мастерством и заботой. От простых подшивов до сложных переделок — мы делаем всё.",
    hero_reviews: "★★★★★ 4.9 от 500+ клиентов",
    hero_trust: "Доверие сотен довольных клиентов по всей Коста-Бланка",
    btn_get_started: "Начать (чат) →",
    hero_subline: "Бесплатная смета · Быстрый ответ · Без обязательств",
    locations_title: "Наши Магазины",
    locations_subtitle: "Три локации для вашего удобства",
    view_map: "Посмотреть на карте →",
    gallery_title: "Наши Работы",
    gallery_subtitle: "Трансформации, созданные для наших клиентов",
    gal_suit: "Пошив Костюмов",
    gal_suit_desc: "Деловой костюм на заказ",
    gal_dress: "Перекрой Платьев",
    gal_dress_desc: "Изменение размера вечернего платья",
    gal_leather: "Ремонт Кожи",
    gal_leather_desc: "Реставрация куртки",
    gal_denim: "Ремонт Джинсов",
    gal_denim_desc: "Починка потёртых джинсов",
    gal_traditional: "Традиционная Одежда",
    gal_traditional_desc: "Корректировка национальной одежды",
    gal_embroidery: "Вышивка",
    gal_embroidery_desc: "Индивидуальная монограмма",
    reviews_title: "Отзывы Клиентов",
    reviews_subtitle: "Что наши клиенты говорят о нас",
    review_1: "Отличный сервис по пошиву одежды! Мне сделали сложную переделку, и вещь выглядит как новая. К тому же персонал был очень дружелюбным, а работа выполнена быстро и профессионально. Обязательно вернусь сюда.",
    review_2: "Превосходный опыт от начала до конца. Качество работы, скорость выполнения и дружелюбие персонала превзошли мои ожидания. В заведении было чисто, цены — разумные, а работа — очень эффективная. Я обязательно вернусь сюда.",
    review_3: "Очень отзывчивый человек, который меня прогнал. Она быстро и по разумной цене починила мои шорты. Работа выполнена на отлично.",
    modal_title: "Спасибо!",
    modal_message: "Ваша заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.",
    footer_desc: "Профессиональные услуги пошива и ремонта с 2010 года. Мы вкладываем мастерство и заботу в каждое изделие.",
    footer_links: "Быстрые Ссылки",
    footer_services: "Услуги",
    footer_contact: "Контакты",
    footer_hours: "Пн-Пт: 9:00-14:30, 16:30-20:00",
    footer_rights: "Все права защищены.",
    svc_alterations: "Перекрой",
    svc_repairs: "Ремонт",
    svc_tailoring: "Индивидуальный Пошив",
    svc_leather: "Работы с Кожей",
    pricing_intro: "Ориентировочные цены на стандартные услуги. Цены могут варьироваться в зависимости от сложности изделия. Запросите персональную смету без обязательств.",
    cat_alterations: "Перекрой Одежды",
    sub_shirts: "РУБАШКИ И БЛУЗКИ",
    item_taper_shirt: "Утяжка (вытачки)",
    item_shorten_sleeve_cuff: "Укоротить рукав (от манжеты)",
    item_shorten_sleeve_shoulder: "Укоротить рукав (от плеча)",
    item_shorten_shirt: "Укоротить длину",
    item_collar: "Изменить воротник / вырез",
    item_narrow_sleeve: "Узить рукав",
    sub_trousers: "БРЮКИ, ДЖИНСЫ И ЮБКИ",
    item_hem_length: "Изменить длину (от низа)",
    item_waist_length: "Изменить длину (от талии)",
    item_waist_trouser: "Изменить пояс (брюки/юбка)",
    item_waist_denim: "Изменить пояс (джинсы)",
    item_waist_suit: "Изменить пояс (брюки костюма)",
    item_taper_legs: "Узить штанину",
    sub_bridal: "СВАДЕБНЫЕ",
    item_bride_length: "Изменить длину",
    item_bride_bodice: "Изменить лиф",
    item_bride_taper: "Утяжка (по швам)",
    item_bride_straps: "Укоротить бретельки",
    sub_jackets: "ПИДЖАКИ И ПАЛЬТО",
    item_jacket_length: "Укоротить / удлинить",
    item_jacket_sleeve: "Изменить длину рукава",
    item_jacket_shoulder: "Поднять плечи",
    item_jacket_taper: "Утяжка",
    sub_dresses: "ПЛАТЬЯ",
    item_dress_hem: "Изменить длину (от низа)",
    item_dress_waist: "Изменить длину (от талии)",
    item_dress_straps: "Укоротить бретельки",
    item_dress_neckline: "Изменить вырез",
    item_dress_taper: "Утяжка (по швам)",
    sub_evening: "ВЕЧЕРНИЕ ПЛАТЬЯ",
    item_evening_length: "Изменить длину",
    item_evening_bodice: "Изменить лиф",
    item_evening_taper: "Утяжка (по швам)",
    item_evening_straps: "Укоротить бретельки",
    cat_repairs: "Ремонт Одежды",
    sub_general: "ОБЩИЕ",
    item_repair_seam: "Ремонт шва",
    item_button: "Пришить пуговицу",
    item_zipper: "Замена молнии",
    item_tear: "Ремонт разрыва",
    item_repair_lining: "Ремонт подкладки",
    item_replace_lining: "Замена подкладки",
    sub_knitwear: "ТРИКОТАЖ",
    item_debobble: "Удаление катышков",
    item_darn_visible: "Штопка (видимая), за отверстие",
    item_darn_invisible: "Штопка (невидимая), за отверстие",
    sub_outerwear: "ВЕРХНЯЯ ОДЕЖДА",
    item_outer_tear: "Ремонт разрыва",
    item_outer_zipper: "Замена молнии",
    item_outer_lining: "Замена подкладки",
    cat_bespoke: "Индивидуальные Услуги",
    item_hand_embroidery: "Ручная вышивка",
    item_machine_embroidery: "Машинная вышивка",
    item_embellishment: "Ремонт / замена отделки",
    item_dyeing: "Техники окрашивания",
    item_denim_paint: "Роспись джинсов",
    item_upcycling: "Переделка одежды",
    item_made_measure: "Пошив на заказ",
    item_fur: "Ремонт и реставрация меха",
    price_on_request: "По запросу",
    cat_leather: "Кожа и Сумки",
    item_bag_zipper: "Замена молнии",
    item_bag_colour: "Реставрация цвета",
    item_bag_touchup: "Подкраска цвета",
    item_bag_change_colour: "Изменение цвета",
    item_bag_lining: "Замена подкладки",
    pricing_cta: "Нужна персональная смета?",
    btn_quote: "Запросить Смету",
    pricing_title: "Цены и Услуги"
  }
};

const titles = {
  es: 'Victoria Stil - Arreglos y Confección',
  en: 'Victoria Stil - Tailoring and Repairs',
  ro: 'Victoria Stil - Croitorie și Reparații',
  ru: 'Victoria Stil - Пошив и Ремонт'
};

const pricingTitles = {
  es: 'Precios y Servicios - Victoria Stil',
  en: 'Pricing & Services - Victoria Stil',
  ro: 'Prețuri și Servicii - Victoria Stil',
  ru: 'Цены и Услуги - Victoria Stil'
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [currentLang, setCurrentLang] = useState('es');

  useEffect(() => {
    const savedLang = localStorage.getItem('victoriaStilLang');
    if (savedLang) {
      setCurrentLang(savedLang);
    } else {
      const browserLang = (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase();
      const supportedLangs = ['es', 'en', 'ro', 'ru'];
      const langMap = { 'eng': 'en', 'rum': 'ro', 'ron': 'ro', 'rus': 'ru', 'spa': 'es' };
      const detected = supportedLangs.includes(browserLang) ? browserLang : (langMap[browserLang] || 'es');
      setCurrentLang(detected);
    }
  }, []);

  const setLanguage = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem('victoriaStilLang', lang);
    document.documentElement.lang = lang;
  };

  const t = (key) => {
    return translations[currentLang]?.[key] || translations['es']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ currentLang, setLanguage, t, titles, pricingTitles }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
